import {Directive, OnInit, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';


@Directive({
  selector: '[clickOutside]'
})

export class ClickOutside implements OnInit {

  @Output('clickOutside') clickOutside:EventEmitter<Object> = new EventEmitter(); 

  constructor(private _elementRef : ElementRef) { }

  ngOnInit() {
  }

  @HostListener('document:click', ['$event.target'])
    public onClick(targetElement) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit(null);
        }
    }
}